import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import CarouselGallery from "./CarouselGallery";

export default function ProductPage() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch product details from backend using product ID from URL
  useEffect(() => {
    fetch(`https://stripe-shop-backend-gsck.onrender.com/products/${id}`)
      .then(res => res.json())
      .then(data => {
        setProduct(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (!product) return <div>Product not found.</div>;

  const price = product.prices && product.prices[0] ? product.prices[0].unit_amount : 0;

  return (
    <div className="product-page">
      {/* Breadcrumbs */}
      <nav className="breadcrumbs">
        <Link to="/">Home</Link> &gt; <span>{product.name}</span>
      </nav>
      <h1>{product.name}</h1>
      <CarouselGallery images={product.images} />
      <p>{product.description}</p>
      <p>Price: ${price ? (price / 100).toFixed(2) : 'N/A'}</p>
      {/* Stripe Buy Button placeholder */}
      <button className="buy-btn">Buy with Stripe</button>
    </div>
  );
}
